export default __webpack_public_path__ + "media/images/react_icons/arrow-right-white-0f96e5ecb36bd4454d000024607c3c34.svg";